import { extendTheme } from '@chakra-ui/react'
import { getTokens } from './colorTokens'

const config = {
	initialColorMode: 'system',
	useSystemColorMode: false
}

const theme = extendTheme({
	config,
	fonts: {
		heading: `'Outfit', 'Inter', sans-serif`,
		body: `'Outfit', 'Inter', sans-serif`
	},
	colors: {
		brand: {
			dark: '#09090B',
			light: '#fafafa',
			accent: 'var(--site-accent, #3B82F6)'
		},
		surface: {
			dark: '#18181b',
			light: '#f4f4f5'
		},
		border: {
			dark: '#27272a',
			light: '#e4e4e7'
		},
		text: {
			primary: {
				dark: '#fafafa',
				light: '#18181b'
			},
			secondary: {
				dark: '#a1a1aa',
				light: '#71717a'
			}
		}
	},
	styles: {
		global: (props) => {
			const t = getTokens(props.colorMode)
			return {
				html: {
					scrollbarGutter: 'stable',
					overflowX: 'clip',
					backgroundColor: t.bg
				},
				'body, #root': {
					bg: 'transparent',
					color: t.textPrimary,
					transition:
						'background-color 0.65s cubic-bezier(0.16, 1, 0.3, 1), color 0.65s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.65s cubic-bezier(0.16, 1, 0.3, 1)',
					overflowX: 'clip',
					width: '100%'
				},
				// Hide default cursor globally for premium experience
				'@media (pointer: fine) and (min-width: 62em)': {
					'body, #root': {
						cursor: 'none'
					},
					'a, button, [role="button"], input, select, textarea': {
						cursor: 'none !important'
					}
				},
				// Smooth transitions for all elements but only for color/bg/border
				'*, *::before, &::after': {
					borderColor: t.borderSubtle,
					transition:
						'background-color 0.65s cubic-bezier(0.16, 1, 0.3, 1), color 0.65s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.65s cubic-bezier(0.16, 1, 0.3, 1)'
				},
				'@keyframes theme-fade-out': {
					from: {
						opacity: 1,
						filter: 'brightness(1) saturate(1)'
					},
					to: {
						opacity: 0,
						filter: 'brightness(0.985) saturate(0.98)'
					}
				},
				'@keyframes theme-fade-in': {
					from: {
						opacity: 0,
						filter: 'brightness(1.015) saturate(1.02)'
					},
					to: {
						opacity: 1,
						filter: 'brightness(1) saturate(1)'
					}
				},
				'::view-transition-old(root), ::view-transition-new(root)': {
					mixBlendMode: 'normal'
				},
				'::view-transition-old(root)': {
					animation: 'theme-fade-out 520ms cubic-bezier(0.16, 1, 0.3, 1) both'
				},
				'::view-transition-new(root)': {
					animation: 'theme-fade-in 700ms cubic-bezier(0.16, 1, 0.3, 1) both'
				},
				'@media (prefers-reduced-motion: reduce)': {
					'*, *::before, &::after': {
						transition: 'none !important'
					},
					'::view-transition-old(root), ::view-transition-new(root)': {
						animation: 'none !important'
					}
				},
				'&::-webkit-scrollbar': {
					width: '0.5rem',
					bg: t.bg
				},
				'&::-webkit-scrollbar-track': {
					bg: 'transparent',
					borderRadius: '3rem'
				},
				'&::-webkit-scrollbar-thumb': {
					bg: t.scrollThumb,
					borderRadius: '3rem'
				}
			}
		}
	},
	components: {
		Button: {
			baseStyle: {
				transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
			}
		},
		Link: {
			baseStyle: {
				transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
				_hover: {
					textDecoration: 'none'
				}
			}
		}
	}
})

export default theme
